<template>
  <div>

    <div class="bb-spinner" v-show="parsing">
      <div class="bb-spiner__content">
        <div class="bb-spinner__dots">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="bb-spinner__title">{{ $t("freeAdd.loadingMessage") }}</div>
        <div class="bb-spinner__p">
          {{ $t("freeAdd.loadingMessageAdv") }} <br />{{ $t("freeAdd.cancel1") }}
          <a @click.prevent="cancel()">{{ $t("freeAdd.cancel2") }}</a>
        </div>
      </div>
    </div>
    <div v-show="!parsing">
      <div class="bb-container">
        <AddProductAlert />
        <portal-target name="alerts_add_product_page" />

        <div v-if="popupHasBeenOpened && !isPopupWindow && !errorNotLoggedIn" class="back">
          <div class="back__back">
            <a @click.prevent="close()">
              <div class="back__name">
                <img
                  src="../../../assets/img/ico/ico-close.svg"
                  alt="Cerrar"
                  class="back__arrow"
                />
              </div>
            </a>
          </div>
        </div>
        <div v-else>
          <div v-if="parsedIncomplete || errorNotLoggedIn" class="alert alert--primary">
            <div class="alert__ico">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11ZM12.38 7.08C12.1365 6.97998 11.8635 6.97998 11.62 7.08C11.4973 7.12759 11.3851 7.19896 11.29 7.29C11.2017 7.3872 11.1306 7.49882 11.08 7.62C11.024 7.73868 10.9966 7.86882 11 8C10.9992 8.13161 11.0245 8.26207 11.0742 8.38391C11.124 8.50574 11.1973 8.61656 11.29 8.71C11.3872 8.79833 11.4988 8.86936 11.62 8.92C11.7715 8.98224 11.936 9.00632 12.099 8.99011C12.2619 8.97391 12.4184 8.91792 12.5547 8.82707C12.691 8.73622 12.8029 8.61328 12.8805 8.46907C12.9582 8.32486 12.9992 8.16378 13 8C12.9963 7.73523 12.8927 7.48163 12.71 7.29C12.6149 7.19896 12.5028 7.12759 12.38 7.08ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
                  fill="#0C5460"
                />
              </svg>
            </div>
            <div class="alert__content" v-if="parsedIncomplete">
              {{ $t("freeAdd.noticeIncomplete") }}
            </div>
            <div class="alert__content" v-else-if="errorNotLoggedIn">
              {{ $t("freeAdd.mustLoginToSave") }}
            </div>
            <div class="alert__content" v-else>
              {{ $t("generic.errorNoSave") }}
            </div>
            <span class="alert__close" @click="errorNotLoggedIn = false;">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.6979 6L12 10.3021L10.3021 12L6 7.6979L1.6979 12L0 10.3021L4.3021 6L0 1.6979L1.6979 0L6 4.3021L10.3021 0L12 1.6979L7.6979 6Z"
                  fill="#004085"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="g-edit">
          <div class="g-edit__header">
            <h1 class="g-edit__title">{{ $t("productPage.editProduct") }}</h1>
            <div class="g-edit__musthave">
              <must-have-toggle-intern
                :product="{ mustHave: mustHave }"
                @markAsMustHave="mustHave = true"
                @markAsnotMustHave="mustHave = false"
              />
            </div>
          </div>
          <div class="g-edit__cols">
            <div class="g-edit__picture">
              <h3 class="g-edit__head">{{ $t("productPage.productImage") }}</h3>
              <div class="g-edit__head-info" v-if="canAddImages">
                {{ $t("freeAdd.selectIdentifyingPicture") }}
              </div>

              <div class="add-free-picture">
                <div class="add-free-picture__items">
                  <no-ssr>
                    <VueSlickCarousel
                      v-if="showSlider"
                      v-bind="settings"
                      ref="carousel"
                      :key="$route.fullPath"
                    >
                      <div
                        v-for="(image, index) in images"
                        @click="selectImage(image)"
                        :key="index"
                      >
                        <div
                          class="add-free-picture__item"
                          :class="{ selected: imageUrl === image }"
                        >
                          <div v-if="canAddImages" class="add-free-picture__overlay"></div>
                          <span
                            v-if="canAddImages"
                            class="add-free-picture__delete"
                            @click.prevent.stop="removeImage(image)"
                          >
                            <img
                              src="../../../assets/img/ico/ico-delete-circle.svg"
                              alt=""
                            />
                          </span>
                          <img
                            :src="image"
                            loading="lazy"
                            width="100%"
                            height="auto"
                            class="add-free-picture__img"
                          />
                        </div>
                      </div>
                      <template #prevArrow="arrowOption">
                        <div class="slick-arrow--back">
                          {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
                          <img
                            src="../../../assets/img/ico/ico-arrow-slick-left.svg"
                            alt=""
                          />
                        </div>
                      </template>
                      <template #nextArrow="arrowOption">
                        <div class="slick-arrow--next">
                          {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
                          <img
                            src="../../../assets/img/ico/ico-arrow-slick-left.svg"
                            alt=""
                          />
                        </div>
                      </template>
                    </VueSlickCarousel>
                  </no-ssr>
                </div>
              </div>
              <no-ssr>
                <div class="g-edit__upload" v-if="canAddImages">
                  <div
                    class="g-edit__upload-error"
                    v-if="this.images && this.images.length > 12"
                  >
                    {{ $t("productPage.notMoreThan12") }} <br />
                    {{ $t("productPage.removeToUploadMore") }}
                  </div>

                  <div class="g-edit__upload-input">
                    <input
                      type="file"
                      @change="previewAddedImage($event)"
                      name="uploadfile"
                      id="img"
                      style="display: none"
                      accept="image/*"
                    />
                    <label class="button button--dark-outline button--block" for="img"
                      >{{ $t("productPage.uploadImage") }}</label
                    >
                    <div class="bb-form-error" v-if="errorMsg">
                      {{ this.errorMsg }}
                    </div>
                    <p v-else>{{ $t("generic.photoMaxSize") }}</p>
                  </div>
                </div>
              </no-ssr>
            </div>
            <div class="g-edit__content">
              <must-have-toggle-intern :product="{ mustHave: mustHave }" />

              <h3 class="g-edit__head header-4">{{ $t("productPage.productData") }}</h3>

              <div class="edit-data">
                <div class="edit-data__item">
                  <div class="bb-form-item">
                    <div class="bb-form-label">{{ $t("generic.name") }}*</div>
                    <input
                      v-model="name"
                      class="bb-form"
                      type="text"
                      maxlength="256"
                      name="name"
                      id="name"
                      required=""
                      @blur="nameBlur"
                    />
                    <div class="bb-form-error" v-show="nameHasError">
                      {{ $t("freeAdd.nameRequired") }}
                    </div>
                  </div>
                </div>

                <div class="edit-data__item">
                  <div class="bb-form-item">
                    <div class="bb-form-label">{{ $t("generic.price") }}*</div>
                    <input
                      v-model="price"
                      class="bb-form"
                      type="number"
                      maxlength="256"
                      name="price"
                      id="price"
                      required=""
                      @blur="priceBlur"
                    />
                    <div class="bb-form-error" v-show="priceHasError">
                      {{ $t("freeAdd.priceRequired") }}
                    </div>
                  </div>
                </div>
                <div class="edit-data__item">
                  <div class="bb-form-item">
                    <div class="bb-form-label">{{ $t("generic.category") }}*</div>

                    <div
                      @blur="categoryDirty = true"
                      tabindex="0"
                      class="bb-filter bb-filter--block"
                      v-click-outside="config"
                    >
                      <div
                        class="bb-filter__select bb-filter__select--block bb-filter__select--form"
                        @click="toggle"
                        :class="toggleCategories ? 'bb-filter__select--active' : ''"
                      >
                        {{ categoryLabel }}
                        <img
                          src="../../../assets/img/ico/ico-chevron-up.svg"
                          loading="lazy"
                          alt=""
                          width="16px"
                          :class="
                            toggleCategories
                              ? 'bb-filter__chevron bb-filter__chevron--active'
                              : 'bb-filter__chevron '
                          "
                        />
                      </div>
                      <div class="bb-filter__items" v-show="toggleCategories">
                        <div
                          class="bb-filter__item bb-filter__item--option"
                          v-for="(category, index) in translatedCategories"
                          :key="index"
                          @click="applyCategory(category)"
                          :class="
                            category.id === categorySelected
                              ? 'bb-filter__item--active'
                              : ''
                          "
                        >
                          <span v-text="category.name" />
                        </div>
                      </div>
                    </div>

                    <div class="bb-form-error" v-show="categoryHasError">
                      {{ $t("freeAdd.categoryRequired") }}
                    </div>
                  </div>
                </div>
                <div class="edit-data__item">
                  <div class="bb-form-item">
                    <div class="bb-form-label">{{ $t("productPage.comments") }}</div>
                    <textarea
                      v-model="userComments"
                      class="bb-form-textarea"
                      type="text"
                      maxlength="256"
                      row="4"
                      name="userComments"
                      id="userComments"
                      required=""
                    />
                  </div>
                </div>
              </div>

              <div class="edit-status">
                <h4 class="edit-status__title">{{ $t("generic.status") }}</h4>
                <div class="edit-status__items">
                  <div v-for="(stateObj,index) in states" :key="index" class="edit-status__item">
                    <input
                      :id="'state_' + stateObj.name"
                      :key="stateObj.id"
                      v-model="state"
                      :value="stateObj"
                      type="radio"
                      :disabled="product.status !== RESERVADO && stateObj.id === RESERVADO"
                    />
                    <label
                      :for="'state_' + stateObj.name"
                      class=""
                      :disabled="product.status !== RESERVADO && stateObj.id === RESERVADO"
                    >
                      {{ stateObj.name }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="g-edit__actions-column">
                <LoadingButton v-if="saving" />
                <button
                  v-else
                  class="button button--primary button--block"
                  @click.prevent="save"
                  :disabled="disabled"
                >
                  {{ $t("generic.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import NoSSR from "vue-no-ssr";
import vClickOutside from "v-click-outside";

import LoadingButton from "../../../components/LoadingButton";

import CanGetOwnerList from "../../../Mixins/CanGetOwnerList";
import CanGetCategories from "../../../Mixins/CanGetCategories";
import WindowMessages from "../../../Mixins/WindowMessages";

import AddProductAlert from "../../constructor/components/AddProductAlert";

import CustomizableIframe from "../mixins/CustomizableIframe";

import MustHaveToggleIntern from "./MustHaveToggleIntern";

export default {
  name: "EditProductModal",
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  mixins: [
    CanGetOwnerList,
    CanGetCategories,
    CustomizableIframe,
    WindowMessages,
  ],
  components: {
    VueSlickCarousel,
    MustHaveToggleIntern,
    LoadingButton,
    "no-ssr": NoSSR,
    AddProductAlert,
  },
  metaInfo() {
    return {
      title: `Añadir objeto | HelloBB`,
    };
  },
  data() {
    return {
      canAddImages: false,

      state: {},
      loaded: false,
      popupHasBeenOpened: false,
      preview: false,
      errorMsg: null,
      showSlider: false,
      mustHave: false,
      showModalProductAdded: false,
      showModalPopup: false,
      error: false,
      parsing: false,
      parsedIncomplete: false,
      urlFromParser: "",
      name: "",
      nameDirty: false,
      url: "",
      html: "",
      imageUrl: "",
      urlDirty: false,
      price: "",
      priceDirty: false,
      userComments: "",
      categorySelected: null,
      categoryDirty: false,
      saving: false,
      askUserToLogin: false,
      isSignup: false,
      config: {
        handler: this.closeCategories,
        events: ["dblclick", "click"],
      },
      toggleCategories: false,
      productPhotos: [],
      productUploadedPhotos: [],
      currentIndex: 0,
      errorNotLoggedIn: false,
      settings: {
        draggable: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        rows: 3,
        arrows: true,
        infinite: false,
        slidesPerRow: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              rows: 1,
              slidesToShow: 1,
              slidesToScroll: 2,
              // slidesPerRow: 1,
              infinite: false,
              dots: true,
              arrows: false,
            },
          },
        ],
      },
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      listActive: "listActive",
      isServer: "isServer",
      product: "ownerListProduct",
      user: "user",
    }),
    defaultPhotoIndex() {
      let x = this.productPhotos.indexOf(this.imageUrl);
      if (x === -1) {
        return (
          this.productPhotos.length +
          this.productUploadedPhotos.indexOf(this.imageUrl) +
          1
        );
      }
      return x + 1;
    },
    images() {
      const allImages = this.$utils.removeDuplicates([
        ...this.productUploadedPhotos,
        ...this.productPhotos,
      ]);

      const firstImage = allImages[0];
      if (!firstImage) {
        return [];
      }
      return [firstImage];
    },
    disabled() {
      if (
        this.name !== "" &&
        this.url !== "" &&
        this.price !== "" &&
        this.price !== "-1" &&
        !isNaN(this.price.replace(",", "."))
      ) {
        return false;
      }
      return true;
    },
    categoryLabel() {
      const category = this.categories.find((category) => category.id === this.categorySelected);
      let translatedName = "";
      const categoryId = category?.id;
      if (categoryId) {
        translatedName = this.getTranslatedCategory(categoryId);
      }
      return translatedName || category?.name || "";
    },
    nameHasError() {
      return this.name === "" && this.nameDirty;
    },
    priceHasError() {
      return (this.price == "" || this.price == -1) && this.priceDirty;
    },
    categoryHasError() {
      return this.categorySelected === null && this.categoryDirty;
    },
    translatedCategories() {
      return this.categories.map((category) => ({
        ...category,

        name: this.getTranslatedCategory(category.id) || category.name,
      }));
    },
    hideFullPage() {
      return this.showModalProductAdded || this.askUserToLogin || this.showModalPopup;
    },
    isPopupWindow() {
      return this.$route.query.popup === "1";
    },
    logoUrl() {
      return this.customizations?.images?.logoUrl || "";
    },
  },
  methods: {
    previewAddedImage(event) {
      this.previewPhoto(event);
      this.$refs.carousel.goTo(0);
    },
    max(...items) {
      return items.reduce((a, b) => (a > b ? a : b), 0);
    },
    cancel() {
      this.parsing = false;
    },
    showNext() {
      this.$refs.carousel.next();
    },
    showPrevious() {
      this.$refs.carousel.prev();
    },
    async save() {
      this.saving = true;
      await this.updateFreeProductData();

      this.$emit("update");
    },
    async updateFreeProductData() {
      const body = {
        name: this.name,
        info: this.userComments,
        price: parseFloat(this.price.replace(",", ".")),
        url: this.url,
        mainCategoryId: this.categorySelected,
        productPhotos: this.productPhotos,
        productUploadedPhotos: this.productUploadedPhotos.map((photo) => photo.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "")),
        defaultPhotoIndex: this.defaultPhotoIndex,
      };

      const mustHave = this.mustHave
        ? "musthave"
        : "notmusthave";

      await this.$store.dispatch("updateFreeProductData", { listId: this.user?.listId, product: this.product, body });
      await this.$store.dispatch("updateFreeProductStatus", { list: this.list, product: this.product, status: this.state.id });
      await this.$store.dispatch("setFreeProductMustHave", { list: this.list, product: this.product, musthave: mustHave });
    },
    async parse(html = "") {
      var bodyObject = {
        userid: "366",
        parsedfrom: "link-web",
        htmlCode: html,
      };
      this.parsing = true;

      let data;
      try {
        this.url = this.$route.query.url;
        data = await this.$parseUrl(this.$route.query.url, {
          method: "POST",
          body: bodyObject,
        });
      } catch (error) {
        console.log(error);
        this.error = true;
        this.parsing = false;
        this.$store.commit("setParserError", true);
        this.$store.commit("setParserErrorUrl", this.$route.query.url);
        return;
      }

      if (this.parsing) {
        if (data.Amount) this.price = String(data.Amount);
        if (data.Title) this.name = data.Title;
        if (data.Images) {
          this.productPhotos = data.Images;
          this.imageUrl = this.productPhotos[0];
          if (this.images.length > 0) this.showSlider = true;
        }
        if (data.Url) {
          this.urlFromParser = data.Url;
          this.url = this.urlFromParser;
        } else {
          this.url = this.$route.query.url;
        }

        this.checkParsing();
      }

      this.parsing = false;
    },
    checkParsing() {
      if (this.price == -1 || this.price == "") {
        this.parsedIncomplete = true;
        this.priceDirty = true;
      }
      if (this.name == "") {
        this.parsedIncomplete = true;
        this.nameDirty = true;
      }
    },
    close() {
      this.$emit("close");
    },
    sendMessageToParentWindow(type, payload = null) {
      window.parent.postMessage({
        source: "hellobb",
        type,
        payload,
      }, "*");
    },
    toggle() {
      this.toggleCategories = !this.toggleCategories;
    },
    applyCategory(category) {
      this.categorySelected = category.id;
      this.toggleCategories = false;
    },
    closeCategories() {
      this.toggleCategories = false;
    },
    nameBlur() {
      this.nameDirty = true;
    },
    urlBlur() {
      this.urlDirty = true;
    },
    priceBlur() {
      this.priceDirty = true;
    },
    getList() {
      return this.$store.dispatch("getOwnerList");
    },
    async isLoggedIn() {
      try {
        const connectedUser = await this.$store.dispatch("getConnectedUser");

        return connectedUser.id > 0;
      } catch (err) {
        console.error(err);

        return false;
      }
    },
    updateDataOutsideModal() {
      this.$emit("update", {
        askUserToLogin: this.askUserToLogin,
        showModalPopup: this.showModalPopup,
        loaded: this.loaded,
      });
    },
    onMessageSetHtml(message) {
      this.html = message.payload;
    },
    async proceedGetProduct() {
      this.$store.commit("setOwnerListProduct", {});
      try {
        await this.getProduct();
      } catch (error) {
        console.log(error);
        if (error.response?.status === 404) {
          // TODO: Handle product not found (?).
        }
        throw error;
      }
    },
    async getProduct(server = false) {
      let payload = {
        productId: this.productId,
      };

      payload.listId = this.user?.listId;

      if (server) {
        payload.server = server;
      }

      await this.$store.dispatch("getOwnerListFreeProduct", payload);
    },
    updatePrice (selectedVariant) {
      if (selectedVariant) {
        this.price =  selectedVariant.price?.toString();
        return;
      }
      this.price = this.product.price?.toString();
    },
    updateState() {
      this.state = this.states.find((state) => state.id === this.product.status);
    },
    close() {
      this.$emit("close");
    },
  },
  async beforeMount() {
    this.sendMessageToParentWindow("getCustomizations");
    this.sendMessageToParentWindow("getHtml");

    await this.proceedGetProduct();
    await this.$store.dispatch("getCategories");
  },
  created() {
    this.PENDIENTE = 1;
    this.REGALADO = 2;
    this.RESERVADO = 3;
    this.states = [
      {
        id: this.PENDIENTE,
        name: this.$t("generic.available"),
      },
      {
        id: this.REGALADO,
        name: this.$t("generic.purchased"),
      },
      {
        id: this.RESERVADO,
        name: this.$t("generic.reserved"),
      },
    ];
  },
  async mounted() {
    const type = this.product.isFree ? "free" : "catalog";
    if (
        parseInt(this.product.id) !== parseInt(this.$route.params.id) ||
        type !== this.$route.params.productType
    ) {
      await this.proceedGetProduct()
    } else {
      if (!this.product.server) {
        await this.proceedGetProduct()
      }
    }

    if (!this.product.id) return;
    this.productIsReady = true

    this.imageUrl = this.$getImgUrl(
      this.product.photos?.find((photo) => photo.main)?.path
    );
    this.productPhotos = this.product.photos?.map((photo) => this.$getImgUrl(photo.path));
    if (this.images.length > 0) this.showSlider = true;

    this.name = this.product.name;
    this.url = this.product.isFree
      ? this.product.originalUrl
      : "https://www.hellobb.net/" +
        this.$formatUrlhelloBB(this.product.brand || "") +
        "/" +
        this.product.id;
    this.userComments = this.product.userComments;

    this.updatePrice(this.selectedVariant)

    this.loaded = true;

    this.updateState();

    this.categorySelected = this.product.mainCategoryId;
  },
};
</script>
